import React, { Component } from 'react';
import get from 'lodash/get';
import has from 'lodash/has';
import PropTypes from 'prop-types';

import {
  Form,
  Input,
  Button,
  Select,
  Tabs,
  Icon,
  Steps,
  Upload,
  Checkbox,
} from 'antd';
import message from 'antd/lib/message';
import { capitalize } from 'shared/utils/StringUtil';
import { numericInput, validatorAmountRange } from 'shared/utils/FormUtil';

import { InfoIcon } from 'modules/AllBillers/components/Icons';
import * as FormComponent from 'modules/AllBillers/components/FormBuilder';
import Modal from 'modules/AllBillers/components/FormBuilder/components/Modal/Modal.display.component';

import { handleUpload, fileUploaderService } from 'shared/utils/FilesUtil';

import PreviewComponent from '../Preview/PreviewComponent.component';

import './AssignComponent.form.style.less';

const { Option } = Select;
const { TabPane } = Tabs;
const { Step } = Steps;

class AssignComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeKey: '1',
      resetValue: false,
      helperImage: {
        imageUrl: null,
        loading: false,
      },
      step: 0,
    };
  }

  renderOptions() {
    const { isPayment } = this.props;
    const paymentOptions = [
      'AmountInput',
      'AmountInputPredefined',
      'InformationCard',
    ];
    const source = isPayment ? paymentOptions : Object.keys(FormComponent);
    return source.map(component => {
      const { label, value } = FormComponent[component].componentDetail;
      return (
        <Option key={value} value={value}>
          {label}
        </Option>
      );
    });
  }

  handleSubmit = e => {
    e.preventDefault();
    const {
      form: { validateFields },
    } = this.props;

    validateFields(this.onValidate);
  };

  onValidate = (err, values) => {
    if (has(err, 'config.id')) {
      this.setState({ activeKey: has(err, 'config.id.general') ? '1' : '2' });
    } else if (has(err, 'config.en')) {
      this.setState({
        activeKey: has(err, 'config.en.general') ? '1' : '2',
        step: 0,
      });
    } else if (!err) this.props.onSubmit(values);
  };

  _fileUploadCallback = formName => (res, fileInfo, status) => {
    const form = formName.substring(10, formName.length);
    if (status === 'success') {
      // set preview image source
      this.setState(
        {
          helperImage: {
            imageUrl: get(res, 'data.payload.abs_path_url'),
            loading: false,
          },
        },
        () => {
          // set image url
          this.props.form.setFieldsValue({
            [`config.en.${form}`]: get(res, 'data.payload.abs_path_url'),
            [`config.id.${form}`]: get(res, 'data.payload.abs_path_url'),
          });
          message.success({
            content: 'Image Uploaded',
            key: 'imageUpload',
          });
        },
      );
    } else {
      this.setState(
        prevState => ({
          helperImage: {
            imageUrl: get(prevState, 'helperImage.imageUrl'),
            loading: false,
          },
        }),
        () => {
          message.error({
            content: 'Failed Upload Image!',
            key: 'imageUpload',
          });
        },
      );
    }
  };

  _fileUpload = formName => file => {
    this.setState(
      prevState => ({
        helperImage: { ...prevState.helperImage, loading: true },
      }),
      () => {
        fileUploaderService(file, this._fileUploadCallback(formName));
      },
    );
  };

  _invalidImageCallback = (formName, initialValue = null) => () => {
    const form = formName.substring(10, formName.length);

    this.setState(
      prevState => ({
        helperImage: {
          imageUrl: get(prevState, 'helperImage.imageUrl') || initialValue,
          loading: false,
        },
      }),
      () => {
        const imgUrl = get(this.state, 'helperImage.imageUrl') || initialValue;
        if (imgUrl) {
          this.props.form.setFields({
            [`config.en.${form}`]: {
              value: imgUrl,
            },
            [`config.id.${form}`]: {
              value: imgUrl,
            },
          });
        } else {
          this.props.form.setFields({
            [`config.en.${form}`]: {
              value: null,
              errors: [new Error('Invalid file')],
            },
            [`config.id.${form}`]: {
              value: null,
              errors: [new Error('Invalid file')],
            },
          });
        }
      },
    );
  };

  _renderUploadIcon = (formName, initialValue) => {
    const { helperImage } = this.state;
    const props = {
      name: 'service-icon',
      listType: 'picture-card service-icon',
      className: 'service-icon',
      multiple: false,
      fileList: false,
      showUploadList: false,
      beforeUpload: () => false,
      onChange: handleUpload(
        {
          maxSize: 500,
          maxDimension: {
            width: 450,
            height: 315,
          },
        },
        this._fileUpload(formName),
        this._invalidImageCallback(formName, initialValue),
      ),
    };

    const initValue = this.state.resetValue ? undefined : initialValue;

    const imgUrl = helperImage.imageUrl || initValue;

    return (
      <Upload {...props}>
        {imgUrl && !helperImage.loading ? (
          <img src={imgUrl} alt="service-icon" />
        ) : (
          <div>
            <Icon type={helperImage.loading ? 'loading' : 'plus'} />
          </div>
        )}
      </Upload>
    );
  };

  _checkPredifinedAmountValidation = () => {
    const {
      form: { validateFields },
    } = this.props;

    const predefinedConfig = [
      'config.en.general.predefined Value 1',
      'config.en.general.predefined Value 2',
      'config.en.general.predefined Value 3',
      'config.en.general.predefined Value 4',
      'config.id.general.predefined Value 1',
      'config.id.general.predefined Value 2',
      'config.id.general.predefined Value 3',
      'config.id.general.predefined Value 4',
    ];

    validateFields(predefinedConfig);
  };

  _onKeyUpInput = (type, formName) => () => {
    if (type === 'number' && formName.includes('predefined Value')) {
      this._checkPredifinedAmountValidation();
    }
  };

  _renderInputType = (type, formItem, formName, initialValue) => {
    const form = formName.substring(10, formName.length);
    let component = (
      <Input
        type="text"
        size="large"
        placeholder={`Enter ${capitalize(formItem)}`}
        onKeyUp={this._onKeyUpInput(type, formName)}
      />
    );
    switch (type) {
      case 'url':
        component = this._renderUploadIcon(formName, initialValue);
        break;
      case 'long':
        component = (
          <Input.TextArea
            rows={4}
            style={{ fontSize: '16px' }}
            placeholder={`Enter ${capitalize(formItem)}`}
          />
        );
        break;
      case 'boolean':
        component = (
          <Checkbox
            className="display-block"
            checked={this.props.form.getFieldValue(`config.en.${form}`)}
            onChange={e => {
              this.setState({
                helperImage: {
                  imageUrl: null,
                  loading: false,
                },
              });
              const {
                target: { checked },
              } = e;

              this.props.form.setFieldsValue({
                [`config.en.${form}`]: checked,
                [`config.id.${form}`]: checked,
              });
            }}
          >
            <div className="checkbox-text">
              Show Helper (<InfoIcon />)
            </div>
          </Checkbox>
        );
        break;
      default:
        break;
    }
    return component;
  };

  _renderComponentTitle = isHelper =>
    isHelper ? (
      <div className="component-form-title">
        Setup configuration for helper <InfoIcon /> section
      </div>
    ) : (
      <div className="component-form-title">
        Setup configuration for general section
      </div>
    );

  _renderDynamicComponentForm = (step, form, isHelper) => {
    const {
      form: { getFieldDecorator, getFieldValue },
      formValue,
    } = this.props;
    const formItemList = Object.keys(form);
    const lang = step === 0 ? 'en' : 'id';
    const formParentName = `config.${lang}.${isHelper ? 'helper' : 'general'}`;
    return (
      <div className="component-form">
        {this._renderComponentTitle(isHelper)}
        {formItemList.map(formItem => {
          let initialValue;
          let rules = [
            {
              required: form[formItem].required,
              message: `Please input ${capitalize(formItem)}`,
            },
          ];
          const value = get(formValue, `${formParentName}.${formItem}`);
          const defaultValue = get(form[formItem], 'defaultValue');

          if (value !== ' ') {
            initialValue = value || defaultValue;
          }

          const maxRule = get(form[formItem], 'max');
          if (maxRule) {
            rules = [...rules, maxRule];
          }

          if (form[formItem].type === 'number') {
            const fieldName = `${formParentName}.${formItem}`;
            const prefixName = fieldName.substring(0, fieldName.length - 1);
            const suffixName = fieldName.substring(fieldName.length - 1);

            const minVal =
              parseInt(
                getFieldValue(`${prefixName}${parseInt(suffixName, 10) - 1}`),
                10,
              ) + 1 || 10000;
            const maxVal =
              parseInt(
                getFieldValue(`${prefixName}${parseInt(suffixName, 10) + 1}`),
                10,
              ) - 1;

            const validator = {
              validator: validatorAmountRange(
                minVal,
                !maxVal ? 5000000 : maxVal,
              ),
            };

            rules = [...rules, validator];
          }

          return (
            <Form.Item
              key={formItem}
              extra={
                form[formItem].type === 'url'
                  ? 'File format only .png with resolution of 450px x 315px and maximum size of 500kb'
                  : null
              }
              required={form[formItem].required}
              label={
                form[formItem].type !== 'boolean' ? capitalize(formItem) : ''
              }
            >
              {getFieldDecorator(`${formParentName}.${formItem}`, {
                ...(form[formItem].type === 'number'
                  ? { getValueFromEvent: numericInput }
                  : {}),
                initialValue: this.state.resetValue ? undefined : initialValue,
                rules,
              })(
                this._renderInputType(
                  form[formItem].type,
                  formItem,
                  `${formParentName}.${formItem}`,
                  initialValue,
                ),
              )}
            </Form.Item>
          );
        })}
      </div>
    );
  };

  _onChangeTab = key => {
    this.setState({ activeKey: key });
  };

  _setActiveTab = key => () => {
    this._onChangeTab(key);
  };

  _renderTabBar = showHelper => () => (
    <div className="tabs">
      <div
        className={`tab-header ${this.state.activeKey === '1' ? 'active' : ''}`}
        onClick={this._setActiveTab('1')}
      >
        General
      </div>

      {showHelper && (
        <div
          className={`tab-header ${
            this.state.activeKey === '2' ? 'active' : ''
          }`}
          onClick={this._setActiveTab('2')}
        >
          Helper
        </div>
      )}
    </div>
  );

  _renderTab = (step, formConfig, componentProps) => {
    const showHelper = get(
      componentProps,
      `${step === 0 ? 'en' : 'id'}.general.withHelper`,
    );
    return (
      <div className="tab-wrapper">
        {formConfig.helper ? (
          <Tabs
            activeKey={this.state.activeKey}
            onChange={this._onChangeTab}
            renderTabBar={this._renderTabBar(showHelper)}
          >
            <TabPane tab="General" key="1">
              {this._renderDynamicComponentForm(step, formConfig.general)}
            </TabPane>

            {showHelper && (
              <TabPane tab="Helper" key="2">
                {this._renderDynamicComponentForm(
                  step,
                  formConfig.helper,
                  true,
                )}
              </TabPane>
            )}
          </Tabs>
        ) : (
          this._renderDynamicComponentForm(step, formConfig.general)
        )}
      </div>
    );
  };

  _getConfigFieldName = lang => {
    const {
      form: { getFieldValue },
      formValue,
    } = this.props;
    const componentValue =
      getFieldValue('component') || get(formValue, 'component');
    const selectedComponent = componentValue
      ? FormComponent[componentValue]
      : null;
    const formConfig = selectedComponent ? selectedComponent.builderConfig : '';
    const listField = ['component', 'name'];
    Object.keys(formConfig).forEach(item => {
      if (item !== 'validation') {
        Object.keys(formConfig[item]).forEach(key => {
          listField.push(`config.${lang}.${item}.${key}`);
        });
      }
    });

    return listField;
  };

  _nextStep = err => {
    if (has(err, 'config.en')) {
      this.setState({ activeKey: has(err, 'config.en.general') ? '1' : '2' });
    } else if (!err) {
      this.setState({ step: 1, activeKey: '1' });
    }
  };

  _changeStep = step => () => {
    if (step === 1) {
      const {
        form: { validateFields },
      } = this.props;
      validateFields(this._getConfigFieldName('en'), this._nextStep);
    } else {
      this.setState({ step });
    }
  };

  _renderSubmit = () => {
    const { step } = this.state;
    const { formValue } = this.props;

    if (step === 0) {
      return (
        <div>
          <Button type="primary" onClick={this._changeStep(1)}>
            Next
          </Button>
          <Button className="ml-15" onClick={this.props.cancelFunction}>
            Cancel
          </Button>
        </div>
      );
    }

    return (
      <div>
        <Button type="primary" onClick={this.handleSubmit}>
          {formValue ? 'Update' : 'Create'}
        </Button>
        <Button className="ml-15" onClick={this._changeStep(0)}>
          Back
        </Button>
      </div>
    );
  };

  _onComponentChange = value => {
    this.setState(
      {
        step: 0,
        activeKey: '1',
        resetValue: true,
        helperImage: {
          imageUrl: null,
          loading: false,
        },
      },
      () => {
        const name = this.props.form.getFieldValue('name');
        this.props.form.resetFields();
        this.props.form.setFields({
          component: {
            value,
          },
          name: {
            value: name,
          },
        });
      },
    );
  };

  render() {
    const {
      form: { getFieldDecorator, getFieldValue },
      formValue,
    } = this.props;

    const { resetValue, step } = this.state;

    const componentValue =
      getFieldValue('component') || get(formValue, 'component');
    const selectedComponent = componentValue
      ? FormComponent[componentValue]
      : null;
    const formConfig = selectedComponent ? selectedComponent.builderConfig : '';
    const componentProps = getFieldValue('config') || get(formValue, 'config');

    const accountInput = [
      'AlphanumericCustomerNumber',
      'NumericCustomerNumber',
      'NumericCustomerNumberNoPrefix',
      'PhoneNumberInput',
    ];

    const isAccountInput =
      accountInput.findIndex(component => component === componentValue) !== -1;

    return (
      <Form>
        <div className="step-language" style={{ width: '320px' }}>
          <Steps current={this.state.step}>
            <Step title="English" />
            <Step title="Indonesian" />
          </Steps>
        </div>
        <Form.Item required label="Component">
          {getFieldDecorator('component', {
            initialValue: resetValue ? undefined : get(formValue, 'component'),
            rules: [
              {
                required: true,
                message: 'Please select component',
              },
            ],
          })(
            <Select
              size="large"
              placeholder="Select component"
              onChange={this._onComponentChange}
              className="select-component"
            >
              {this.renderOptions()}
            </Select>,
          )}
        </Form.Item>

        <Form.Item required label="Component Name">
          {getFieldDecorator('name', {
            initialValue: resetValue ? undefined : get(formValue, 'name'),
            rules: [
              {
                required: true,
                message: 'Please input component name',
              },
            ],
          })(
            <Input
              type="text"
              size="large"
              placeholder="Enter component name"
            />,
          )}
        </Form.Item>

        {isAccountInput && (
          <>
            <Form.Item required label="Validation Min Length">
              {getFieldDecorator('validation.minLength', {
                initialValue: resetValue
                  ? get(formConfig, 'validation.minLength.defaultValue')
                  : get(formValue, 'validation.minLength') ||
                    get(formConfig, 'validation.minLength.defaultValue'),
                getValueFromEvent: numericInput,
                rules: [
                  {
                    required: true,
                    message: 'Please input validation min length',
                  },
                  {
                    validator: validatorAmountRange(
                      1,
                      parseInt(getFieldValue(`validation.maxLength`), 10),
                    ),
                  },
                ],
              })(
                <Input
                  type="text"
                  size="large"
                  placeholder="Enter Min Length Validation"
                  onKeyUp={() => {
                    this.props.form.validateFields([
                      'validation.minLength',
                      'validation.maxLength',
                    ]);
                  }}
                />,
              )}
            </Form.Item>

            <Form.Item required label="Validation Max Length">
              {getFieldDecorator('validation.maxLength', {
                initialValue: resetValue
                  ? get(formConfig, 'validation.maxLength.defaultValue')
                  : get(formValue, 'validation.maxLength') ||
                    get(formConfig, 'validation.maxLength.defaultValue'),
                getValueFromEvent: numericInput,
                rules: [
                  {
                    required: true,
                    message: 'Please input validation max length',
                  },
                  {
                    validator: validatorAmountRange(
                      parseInt(getFieldValue(`validation.minLength`), 10),
                      100,
                    ),
                  },
                ],
              })(
                <Input
                  type="text"
                  size="large"
                  placeholder="Enter Max Length Validation"
                  onKeyUp={() => {
                    this.props.form.validateFields([
                      'validation.minLength',
                      'validation.maxLength',
                    ]);
                  }}
                />,
              )}
            </Form.Item>
          </>
        )}

        <div style={{ display: step === 0 ? 'block' : 'none' }}>
          {selectedComponent && (
            <Form.Item label="Preview">
              <div className="preview-component">
                <PreviewComponent
                  selectedComponent={
                    this.state.activeKey === '1' ? selectedComponent : Modal
                  }
                  intl={this.props.intl}
                  config={get(componentProps, 'en')}
                />
              </div>
            </Form.Item>
          )}

          {formConfig && this._renderTab(0, formConfig, componentProps)}
        </div>
        <div style={{ display: step === 1 ? 'block' : 'none' }}>
          {selectedComponent && (
            <Form.Item label="Preview">
              <div className="preview-component">
                <PreviewComponent
                  selectedComponent={
                    this.state.activeKey === '1' ? selectedComponent : Modal
                  }
                  intl={this.props.intl}
                  config={get(componentProps, 'id')}
                />
              </div>
            </Form.Item>
          )}

          {formConfig && this._renderTab(1, formConfig, componentProps)}
        </div>

        {this._renderSubmit()}
      </Form>
    );
  }
}

AssignComponent.propTypes = {
  form: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  cancelFunction: PropTypes.func.isRequired,
  formValue: PropTypes.object,
  intl: PropTypes.object,
  isPayment: PropTypes.bool,
};

export default AssignComponent;
